import React, { useState, useEffect, useCallback } from 'react';
import { bannersAPI } from '../lib/api';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function BannerSlider({ pageType }) {
  const [banners, setBanners] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    bannersAPI.list(pageType).then(r => {
      setBanners(r.data?.banners || []);
    }).catch(() => {});
  }, [pageType]);

  const next = useCallback(() => {
    setCurrent(c => (c + 1) % banners.length);
  }, [banners.length]);

  const prev = useCallback(() => {
    setCurrent(c => (c - 1 + banners.length) % banners.length);
  }, [banners.length]);

  // Auto-slide every 4s
  useEffect(() => {
    if (banners.length <= 1) return;
    const timer = setInterval(next, 4000);
    return () => clearInterval(timer);
  }, [banners.length, next]);

  if (!banners.length) return null;

  return (
    <div className="relative w-full rounded-2xl overflow-hidden mb-6 group" data-testid="banner-slider">
      <div className="relative w-full" style={{ paddingBottom: '28%', minHeight: '120px' }}>
        {banners.map((banner, i) => (
          <img
            key={banner.id}
            src={banner.image_url}
            alt={banner.image_name}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${i === current ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
            data-testid={`slide-${i}`}
          />
        ))}
      </div>
      {banners.length > 1 && (
        <>
          <button onClick={prev} className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/30 hover:bg-black/50 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-testid="slide-prev">
            <ChevronLeft className="w-4 h-4" />
          </button>
          <button onClick={next} className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/30 hover:bg-black/50 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-testid="slide-next">
            <ChevronRight className="w-4 h-4" />
          </button>
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5">
            {banners.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`w-2 h-2 rounded-full transition-all ${i === current ? 'bg-white w-5' : 'bg-white/50'}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
